// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"features_wrapper__9cPFL","list":"features_list__M36ud","single":"features_single__YGirF","icon":"features_icon__YFz3D"};